import { render, staticRenderFns } from "./SamFormGroup.vue?vue&type=template&id=4c539c3a&scoped=true&shadow"
import script from "./SamFormGroup.vue?vue&type=script&lang=js&shadow"
export * from "./SamFormGroup.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./SamFormGroup.vue?vue&type=style&index=0&id=4c539c3a&prod&scoped=true&lang=scss&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4c539c3a",
  null
  ,true
)

export default component.exports